var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0H2H18H19V1V4.08296C21.8377 4.55904 24 7.027 24 10C24 11.777 23.2275 13.3736 22 14.4722V22V23.8685L20.4453 22.8321L18 21.2019L15.5547 22.8321L14 23.8685V22V20H2H1V19V1V0ZM14 18V14.4722C12.7725 13.3736 12 11.777 12 10C12 7.027 14.1623 4.55904 17 4.08296V2H3V18H14ZM16 15.6586V20.1315L17.4453 19.1679L18 18.7981L18.5547 19.1679L20 20.1315V15.6586C19.3744 15.8797 18.7013 16 18 16C17.2987 16 16.6256 15.8797 16 15.6586ZM18 6C15.7909 6 14 7.79086 14 10C14 12.2091 15.7909 14 18 14C20.2091 14 22 12.2091 22 10C22 7.79086 20.2091 6 18 6ZM11 9.00001H5V7.00001H11V9.00001ZM5 12H10V10H5V12ZM7 15H5V13H7V15ZM5 6.00001H7V4.00001H5V6.00001Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateSvgrepoCom);
export default __webpack_public_path__ + "static/media/certificate-svgrepo-com.8f6b26cdf6e6be41b36c2131391f9e0b.svg";
export { ForwardRef as ReactComponent };